import React, { useMemo } from 'react'
import { Grid, Typography, Box, Card, Checkbox } from '@mui/material'
import BasicDataGridV2 from 'components/generic/datagrid'
import PropTypes from 'prop-types'
import { useGetPriceSheetQuery } from 'services/priceSheets'
import { useGetDriversQuery } from 'services/drivers'

const CarrierProfileInfo = ({ customerData, driverData }) => {
  const driverColumns = useMemo(
    () => [
      {
        field: 'isActive',
        headerName: 'Active',
        flex: 1,
        editable: false,
        headerAlign: 'center',
        align: 'center',
        renderCell: ({ row }) => {
          return <Checkbox name={`drivers.${row.index}.isActive`} label="" checked={row.isActive} disabled={true} />
        },
      },
      {
        field: 'name',
        headerName: 'Driver Name',
        flex: 2,
        editable: false,
        headerAlign: 'center',
        align: 'center',
      },
      {
        field: 'truckName',
        headerName: 'Truck',
        flex: 2,
        editable: false,
        headerAlign: 'center',
        align: 'center',
      },
      {
        field: 'trailerName',
        headerName: 'Trailer',
        flex: 2,
        editable: false,
        headerAlign: 'center',
        align: 'center',
      },
    ],
    [],
  )

  const { data: linkedDriversData, isFetching: isFetchingLinkedDriversData } = useGetDriversQuery({
    filter: JSON.stringify({ carrierId: customerData?.id }),
  })

  const driverTableData = useMemo(() => {
    if (linkedDriversData?.Items) {
      return linkedDriversData.Items.map(driver => {
        return {
          id: driver.id,
          name: driver.name,
          truckName: driver.truck?.assetName || '-',
          trailerName: driver.trailer?.assetName || '-',
          isActive: driver.isActive,
        }
      })
    }
  }, [linkedDriversData])

  return (
    <Grid container columns={3}>
      <Box p={3} data-testid="customer-profile">
        <Grid container rowSpacing={2}>
          <Grid item xs={3}>
            <Typography variant="h5">Profile Information</Typography>
          </Grid>
          <Grid item xs={3}>
            <Card variant="outlined">
              <Box p={2}>
                <Typography variant="overline">NOTES</Typography>
                <Typography variant="h6">{customerData?.notes || '---'}</Typography>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h5">Carrier Drivers</Typography>
          </Grid>
          <Grid item xs={3}>
            <BasicDataGridV2
              dataTestId="manage-drivers-grid"
              rows={driverTableData}
              columns={driverColumns}
              loading={isFetchingLinkedDriversData}
              disableColumnMenu
              pagination={false}
              components={{
                LoadingOverlay: () => null,
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  )
}
CarrierProfileInfo.propTypes = {
  customerData: PropTypes.shape({
    id: PropTypes.string,
    externalId: PropTypes.number,
    supplierType: PropTypes.string,
    vendorClass: PropTypes.string,
    accountManagerGsUser: PropTypes.shape({
      accountManagerGsUserId: PropTypes.string,
      accountManagerGsUserFirstName: PropTypes.string,
      accountManagerGsUserLastName: PropTypes.string,
    }),
    creditBalance: PropTypes.shape({
      amount: PropTypes.number,
      currency: PropTypes.string,
      precision: PropTypes.number,
    }),
    buysForbidden: PropTypes.bool,
    isSupplier: PropTypes.bool,
    isConsumer: PropTypes.bool,
    isCarrier: PropTypes.bool,
    priceSheetId: PropTypes.string,
    notes: PropTypes.string,
    docs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        createdAt: PropTypes.string,
        uuid: PropTypes.string,
      }),
    ),
  }).isRequired,
}

export default CarrierProfileInfo
